// https://github.com/jameslnewell/styled-components-breakpoint
const breakpoints = {
  xs: 0,
  sm: 768, // 48em
  md: 1024, // 64em
  lg: 1200, // 75em
};

export default breakpoints;
